import { useId as useReactId } from 'react';

export default function useId(id?: string, prefix?: string) {
   const reactId = useReactId();
   return id ?? (prefix ? `${prefix}-${reactId}` : reactId);
}
